// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__23t1m","detailsBorder":"styles_detailsBorder__1H61K"};